module.exports = __webpack_public_path__ + "img/record-video.90930a57.svg";